import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Uncaught error:", error, errorInfo);
    
    // Auto reload on stale chunk import failure (e.g. Failed to fetch dynamically imported module)
    const errStr = error ? (error.message || error.toString()) : '';
    if (errStr.includes('Failed to fetch dynamically imported module') || errStr.includes('Importing a module script failed')) {
      const refreshed = JSON.parse(window.sessionStorage.getItem('chunk_error_refreshed') || 'false');
      if (!refreshed) {
        window.sessionStorage.setItem('chunk_error_refreshed', 'true');
        window.location.reload();
        return;
      }
    }

    this.setState({ errorInfo });
  }


  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div style={{ padding: '20px', textAlign: 'center', fontFamily: 'sans-serif' }}>
          <h1>Something went wrong.</h1>
          <p>We're sorry, but the application encountered an unexpected error.</p>
          <details style={{ whiteSpace: 'pre-wrap', textAlign: 'left', marginTop: '20px', backgroundColor: '#f0f0f0', padding: '10px', borderRadius: '4px' }}>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo && this.state.errorInfo.componentStack}
          </details>
          <button 
            onClick={() => window.location.reload()}
            style={{ marginTop: '20px', padding: '10px 20px', cursor: 'pointer', backgroundColor: '#FF0057', color: 'white', border: 'none', borderRadius: '4px' }}
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;
